import { Identifiable, List } from "@planzone/dto";
import { LinkedList, Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function hasParentListChanged(
  list: Identifiable<List>,
  nextList: List,
): boolean {
  return list.parentList && nextList.parentList
    ? list.parentList.uuid === nextList.parentList.uuid
    : list.parentList !== nextList.parentList;
}

function editList(httpClient: HttpClient, linker: Linker) {
  return (list: Identifiable<List>, nextList: List) =>
    (hasParentListChanged(list, nextList) && nextList.parentList
      ? httpClient.sendHttpRequest<LinkedList>({
          endpoint: `/activities/${list.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            name: nextList.name,
            description: nextList.description,
            startDate: nextList.startDate ? formatDate(nextList.startDate) : "",
            endDate: nextList.endDate ? formatDate(nextList.endDate) : "",
            ...(nextList.activityKeyRank && {
              activityKeyRank: nextList.activityKeyRank,
            }),
            activityParent: `/activities/${
              nextList.parentList ? nextList.parentList.uuid : ""
            }`,
            ...(!!nextList.attributes && {
              attributes: nextList.attributes,
            }),
          },
        })
      : httpClient.sendHttpRequest<LinkedList>({
          endpoint: `/activities/${list.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            name: nextList.name,
            description: nextList.description,
            startDate: nextList.startDate ? formatDate(nextList.startDate) : "",
            endDate: nextList.endDate ? formatDate(nextList.endDate) : "",
            ...(nextList.activityKeyRank && {
              activityKeyRank: nextList.activityKeyRank,
            }),
            ...(!!nextList.attributes && {
              attributes: nextList.attributes,
            }),
          },
        })
    )
      .then((list) => ({
        ...list,
        attributes: { ...nextList.attributes, ...list.attributes },
      }))
      .then(linker.linkList)
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            invalidDateRange: "invalidDateRange",
            startDateOutOfBound: "startDateOutOfBound",
            notFound: "notFound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { editList };
